import React, { Component, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useSelector, useDispatch } from "react-redux";
import {
  Typography,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  TablePagination,
} from "@mui/material";
import ProductCarousel from "../components/ProductCarousel";

import { basePath } from "../utility";
import axios from "axios";

import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import useFetch from "../hooks/useFetch";
import LoginPage from "../components/LoginPage";
import {
  ChevronRight,
  ErrorOutline,
  HourglassDisabledOutlined,
  WifiOffOutlined,
} from "@mui/icons-material";
import CustomCarousel from "../components/custom.slider";
import img1 from "../assets/slider/img1.png";
import img2 from "../assets/slider/img2.png";
import img3 from "../assets/slider/img3.png";
import img4 from "../assets/slider/img4.png";
import mainBannerImage from "../assets/banner1.png";

const Home = () => {
  const navigate = useNavigate();
  const [featured, setFeatured] = useState(null);
  const [published, setPublished] = useState(null);

  const [bookList, setBookList] = useState(null);
  const [loadingBookList, setLoadingBookList] = useState(false);
  const [errorBookList, setErrorBookList] = useState(null);
  const [feedbackBookList, setFeedbackBookList] = useState(null);

  const [searchData, setSearchData] = useState({
    category: "",
    author: null,
    status: "",
  });

  //pagination
  const [controller, setController] = useState({
    page: 1,
    rowsPerPage: 10,
  });
  const [booksCount, setBooksCount] = useState(0);

  const [openLoginDialog, setOpenLoginDialog] = useState(false);
  const [logType, setLogType] = useState(null);

  const url = basePath.url;
  const dispatch = useDispatch();
  const errDialog = useSelector((state) => {
    return state.dialogReducer;
  });

  const user = useSelector((state) => {
    return state.logger.user;
  });

  //   const [authors, isPendingAuthors, errorAuthors] = useFetch(
  //     `${url}books/authors`
  //   );

  // const loadBooks = async () => {
  //   // setBookList(null);
  //   setLoadingBookList(true);
  //   setErrorBookList(null);
  //   setFeedbackBookList(null);

  //   const data = {
  //     category: searchData.category,
  //     author: searchData.author,
  //     status: searchData.status,
  //   };

  //   const baseUrl = `${url}books?page=${controller.page}&size=${controller.rowsPerPage}`;
  //   try {
  //     const result = await axios.post(baseUrl, data);

  //     setLoadingBookList(false);
  //     setErrorBookList(null);

  //     if (result.data.message === "success") {
  //       //console.log(result.data.data);

  //       if (result.data.data.books.length < 1) {
  //         setFeedbackBookList("No Books Found");
  //       }
  //       setBookList(result.data.data.books);
  //       setBooksCount(result.data.data.count);
  //     } else {
  //       setErrorBookList("Error Fetching Books");
  //       setLoadingBookList(false);
  //     }
  //   } catch (err) {
  //     setLoadingBookList(false);
  //     setErrorBookList(err.message);
  //     setFeedbackBookList(null);
  //     // console.log(err);
  //   }
  // };

  // useEffect(() => {
  //   loadBooks();
  // }, []);

  const sliderImages = [
    { id: 1, path: img1 },
    { id: 2, path: img2 },
    { id: 3, path: img3 },
    { id: 4, path: img4 },
  ];
  return (
    <>
      <div
        style={{
          minHeight: "75vh",
          width: "100%",
          // zIndex: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "center",
          // background: "rgb(232, 232, 232)",
          backgroundColor: "transparent",
          // paddingLeft: 20,
          // paddingRight: 20,
          // paddingTop: 20,
          // paddingBottom: 50,
        }}
      >
        <div
          style={{
            width: "100%",
            // height: "60vh",
            margin: 0,
            padding: 0,
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            className="mainBannerWrapper"
            style={{ paddingTop: 50, paddingBottom: 30 }}
          >
            <div className="left" style={{ flex: 1 }}>
              <div
                style={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  // paddingLeft: 20,
                }}
              >
                <div>
                  <Typography
                    className="mainBannerText"
                    variant="h4"
                    style={{ color: "#2d3e50" }}
                  >
                    The East African Univerisity
                  </Typography>

                  <Typography
                    className="mainBannerText"
                    variant="h5"
                    style={{ color: "grey" }}
                  >
                    The Well Spring of Knowledge and Character
                  </Typography>

                  <Typography
                    className="mainBannerText"
                    variant="subtitle2"
                    style={{
                      color: "#131a46",
                    }}
                  >
                    Centre of Professional Excellence
                  </Typography>
                  <div
                    // style={{
                    //   marginTop: "10%",
                    //   display: "flex",
                    //   justifyContent: "flex-start",
                    //   alignItems: "center",
                    //   boxSizing: "border-box",
                    // }}
                    className="mainBannerBtn"
                  >
                    <div
                      className="largeButtonTransparent "
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 10,
                        boxSizing: "border-box",
                      }}
                      onClick={() => {
                        setLogType("signup");
                        setOpenLoginDialog((prev) => {
                          return !prev;
                        });
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        style={{ color: "#181717", fontSize: 16 }}
                      >
                        New Course Application
                      </Typography>
                      <ChevronRight
                        style={{ color: "#c9770c", fontSize: 30 }}
                      />
                    </div>
                    <div></div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="right"
              style={{
                padding: 20,
                boxSizing: "border-box",
                // height: "100%",
                flex: 1,
              }}
            >
              <img src={mainBannerImage} style={{ width: "100%" }} />
              {/* {sliderImages && sliderImages.length > 0 ? (
                <CustomCarousel>
                  {sliderImages.map((item, index) => {
                    return (
                      <img
                        key={index}
                        src={item.path}
                        alt={"image"}
                        style={{
                          objectFit: "scale-down",
                          width: "100%",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          // navigate(`/books/book-details/${book.id}/`);
                        }}
                      />
                    );
                  })}
                </CustomCarousel>
              ) : null} */}
            </div>
          </div>
        </div>

        <div
          style={{
            paddingTop: 50,
            paddingBottom: 50,
            // backgroundColor: "#e9e8e8",
            backgroundColor: "#f7f5f5",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            // style={{
            //   width: "60%",
            //   display: "flex",
            //   justifyContent: "flex-start",
            //   alignItems: "center",
            // }}
            className="contentSection"
            style={{ backgroundColor: "transparent" }}
          >
            <Typography variant="h5" style={{ alignItems: "left" }}>
              Online Registration Guidelines
            </Typography>
          </div>
          <div className="contentSection">
            <div>
              <Typography
                variant="subtitle1"
                style={{ fontWeight: 500, fontSize: "1.25rem" }}
              >
                To join the university as a student, follow the steps below:
              </Typography>

              <ol
                style={{
                  paddingLeft: 20,
                  marginTop: 10,
                }}
              >
                <li
                  style={{
                    fontWeight: 400,
                    fontSize: 14,
                    lineHeight: "2",
                    letterSpacing: "normal",
                  }}
                >
                  Decide the programme that you want to undertake and ensure you
                  meet the programme qualifications stated in the university
                  website "Academics &#10139; Academic Programmes section".
                </li>

                <li
                  style={{
                    fontWeight: 400,
                    fontSize: 14,
                    lineHeight: "2",
                    letterSpacing: "normal",
                  }}
                >
                  Click on "New Course Application" at the top of this web page
                  or at the bottom of this section"
                </li>
                <li
                  style={{
                    fontWeight: 400,
                    fontSize: 14,
                    lineHeight: "2",
                    letterSpacing: "normal",
                  }}
                >
                  You will be required to create an account to proceed with your
                  application. Login if you already have an existing account and
                  click on the "New Application Button to start the application
                  process"
                </li>
                <li
                  style={{
                    fontWeight: 400,
                    fontSize: 14,
                    lineHeight: "2",
                    letterSpacing: "normal",
                  }}
                >
                  Fill in the required information in each step of the
                  application
                </li>
                <li
                  style={{
                    fontWeight: 400,
                    fontSize: 14,
                    lineHeight: "2",
                    letterSpacing: "normal",
                  }}
                >
                  Finish the application process and submit your application.
                </li>
                <li
                  style={{
                    fontWeight: 400,
                    fontSize: 14,
                    lineHeight: "2",
                    letterSpacing: "normal",
                  }}
                >
                  Once your application is submitted successfully, you will
                  receive an email from us indicating your application ID.
                </li>
                <li
                  style={{
                    fontWeight: 400,
                    fontSize: 14,
                    lineHeight: "2",
                    letterSpacing: "normal",
                  }}
                >
                  Pay the indicated application fee{" "}
                </li>
                <li
                  style={{
                    fontWeight: 400,
                    fontSize: 14,
                    lineHeight: "2",
                    letterSpacing: "normal",
                  }}
                >
                  To keep track of your application status, login with the email
                  address and Password used during creation of your account.
                </li>
              </ol>
            </div>
          </div>
        </div>

        {/* <div className="contentSection">
          <div
            style={{
              width: "1100px",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <Typography variant="h5" style={{ alignItems: "left" }}>
              Featured Authors
            </Typography>
          </div>
        </div> */}
        {/* <div
          className="contentSection"
          style={{ backgroundColor: "transparent" }}
        >
          <div
            style={{
              width: "1100px",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <Typography variant="h5" style={{ alignItems: "left" }}>
              Best Selling
            </Typography>
            {book_categories.map((category) => {
              return <></>;
            })}
          </div>
        </div> */}
        <LoginPage
          openLoginDialog={openLoginDialog}
          setOpenLoginDialog={setOpenLoginDialog}
          logType={logType}
          setLogType={setLogType}
        />
      </div>
    </>
  );
};

export default Home;
